export const layerScrollableAreaHeight = '400px'
export const layerOverlayMinHeight = '550px' // Keep child modals height in sync with parent modal
